import React from 'react';
import { GiftIcon } from 'lucide-react';
import { scrollToBuy } from '../utils/constants';
const BONUSES = [{
  number: '01',
  title: 'Communication Support Pack™',
  accent: 'border-l-sage',
  body: 'Support functional communication with practical visual tools for requesting, choosing, asking for help, expressing needs, and participating in everyday activities.',
  tags: 'Communication Cards · Choice Boards · Request Tools · Self-Advocacy Supports'
}, {
  number: '02',
  title: 'Independence & Life Skills Toolkit™',
  accent: 'border-l-lavender',
  body: 'Build greater classroom and everyday independence through structured routines, visual sequences, task strips, checklists, and progression tools.',
  tags: 'Life Skills · Independence · Task Sequences · Checklists · Progression Tools'
}, {
  number: '03',
  title: 'Social & Emotional Support Cards™',
  accent: 'border-l-mustard',
  body: 'Support emotional awareness, communication, regulation, social understanding, and practical problem-solving with ready-to-use visual resources.',
  tags: 'Emotion Cards · Social Scenarios · Regulation · Problem Solving · Visual Supports'
}, {
  number: '04',
  title: 'Low-Prep Learning Games Pack™',
  accent: 'border-l-steel',
  body: 'Bring ready-to-use educational games into lessons without spending hours preparing new activities.',
  tags: 'Matching · Sorting · Sequencing · Communication · Functional Learning'
}, {
  number: '05',
  title: 'Substitute & Emergency Lesson Pack™',
  accent: 'border-l-coral',
  body: 'Handle unexpected changes, absences, schedule disruptions, or low-preparation days with structured activities and ready-to-use lesson resources.',
  tags: 'Emergency Lessons · Quick Activities · Routine Supports · Substitute Guides'
}];
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="w-full bg-cream px-3 py-7 sm:px-5" data-id="element-20" data-mp="np8d0ml1hllw">
      <div className="mx-auto max-w-4xl" data-id="element-21" data-mp="irgbd0ulel4i">
        <div className="text-center" data-id="element-22" data-mp="iqf12ylei2nu">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-sage/20 px-2.5 py-0.5 font-head text-[10px] uppercase tracking-wide text-petrol sm:text-xs" data-id="element-23" data-mp="3ciwoghxmr5fg">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="3hg6gm5celv6z" />
            Also included at no extra cost
          </span>
          <h2 id="bonuses-title" className="mt-1 font-head text-2xl uppercase leading-none text-ink sm:text-4xl" data-id="element-25" data-mp="3qipc24dv15j7">
            Five Strategic Bonuses
          </h2>
          <p className="mt-1 text-[13px] text-muted" data-id="element-26" data-mp="2tu9nobmhl27o">
            100% included today with your SPECIAL EDUCATION TEACHER PRO™ box set.
          </p>
        </div>

        <div className="mt-4 grid gap-2 md:grid-cols-2" data-id="element-27" data-mp="32sv0dq5a1n0j">
          {BONUSES.map((bonus, index) => <button key={bonus.number} type="button" onClick={scrollToBuy} aria-label={`Go to the purchase section — ${bonus.title}`} className={`flex flex-col rounded-xl border border-ink/10 border-l-4 bg-white p-3 text-left transition-colors duration-150 ease-out hover:border-ink/30 ${bonus.accent} ${index === BONUSES.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="37kd6esm5qdsd" data-mpi={index}>
              <span className="text-[10px] font-bold uppercase tracking-widest text-muted" data-id="element-29" data-mp="27hx44w2pxs1x">
                Bonus {bonus.number}
              </span>
              <span className="mt-0.5 block font-head text-lg uppercase leading-tight text-ink sm:text-xl" data-id="element-30" data-mp="1xl276hm3fzpr">
                {bonus.title}
              </span>
              <span className="mt-1 block text-[13px] leading-snug text-body" data-id="element-31" data-mp="1tml3y95sn9dm">{bonus.body}</span>
              <span className="mt-auto block pt-1.5 text-[10px] font-bold uppercase leading-snug tracking-wide text-petrol" data-id="element-32" data-mp="1omyqpzpytt4t">
                {bonus.tags}
              </span>
            </button>)}
        </div>
      </div>
    </section>;
}